import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import { useCallback, useMemo } from 'react';

import { Box } from '@/components/blocks/Box';
import { Icon } from '@/components/blocks/Icon';
import { Text } from '@/components/blocks/Text';
import { theme } from '@/styles/theme';

const Root = styled(Box)(() =>
  css({
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${theme.spaces.l} ${theme.spaces.m}`,
    borderBottom: theme.borders.default,
    backgroundColor: theme.colors.background.default,
    width: '100%',
    position: 'sticky',
    top: 0,
    zIndex: theme.zIndices.header,
  })
);

const IconWrapper = styled(Box)(() =>
  css({
    position: 'absolute',
    left: theme.spaces.m,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  })
);

const TitleWrapper = styled(Box)(() =>
  css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  })
);

const pathTitleMap: Record<string, string> = {
  '/': 'ホーム',
  '/connection_request': 'QRコード読み取り',
  '/patient': '患者設定',
  '/patient/create': '患者設定',
  '/outpatient_questionnaire/organizations': 'Web問診',
  '/outpatient_questionnaire/organizations/[organizationId]': 'Web問診',
  '/outpatient_questionnaire/organizations/[organizationId]/result': 'Web問診',
  '/reception/organizations': '処方箋送信',
  '/reception/organizations/[organizationId]': '処方箋送信',
  '/reception/organizations/[organizationId]/result': '処方箋送信',
  '/requests/[appointmentId]': '処方箋送信',
  '/requests/[appointmentId]/cancel': '処方箋送信',
  '/followup_messages/[medicationFollowupMessageId]/questionnaire_sheet':
    '質問票回答',
  '/followup_messages/[medicationFollowupMessageId]/result': '質問票結果',
};

const getPageTitle = (path: string): string => {
  // liffIdを除いたパス部分を取得（/[liffId]パターンを/に置換）
  const pathWithoutLiffId = path.replace(/^\/[^/]+/, '') || '/';

  return pathTitleMap[pathWithoutLiffId] || 'ホーム';
};

export const Header = () => {
  const router = useRouter();
  const liffId = router.query.liffId as string;
  const path = router.pathname;
  const pageTitle = useMemo(() => getPageTitle(path), [path]);

  const handleClick = useCallback(async () => {
    await router.push({
      pathname: `/${liffId}/`,
    });
  }, [liffId, router]);

  return (
    <Root>
      <IconWrapper>
        <Box onClick={() => void handleClick()}>
          <Icon icon='home' color='default' width='24px' />
        </Box>
      </IconWrapper>
      <TitleWrapper>
        <Text use='l-B'>{pageTitle}</Text>
      </TitleWrapper>
    </Root>
  );
};
